import React, { useState }from "react";
import { Dialog } from "primereact/dialog";
import { Button, TextAreaField } from "../helpers";
import { validateInputs } from "../utils";
import { cancellationReasonSchema } from "../validation/cancellationReason";

const RemarksDialog = (props) => {
    const [reasonText, setReasonText ] = useState("")
    const [formErrors, setFormErrors] = useState({})

    let header = props.header ? props.header : "Cancellation reason"
    let placeholder = props.placeholder ? props.placeholder : "Enter Cancelation Reason"
    
    const handleOnChange = (e) => {
        setReasonText(e.target.value)
    }

    const handleSubmitClick = async () => {
        const stateObj = {
            cancellationReason: reasonText
        }
        const validationResponse = await validateInputs(cancellationReasonSchema, stateObj)
        console.log("validationResponse", validationResponse)
        if(validationResponse.error){
            setFormErrors(validationResponse.error)
        }else{
            props.onSubmit(reasonText)
            setFormErrors({})
            setReasonText("")
        }
    }

    const footerContent = () => {
        return(
            <div>
                <Button label="Cancel" severity="danger" outlined onClick={() => {props.onHide(); setFormErrors({}); setReasonText("")}}/>
                <Button label="Submit" severity="" outlined onClick={() => handleSubmitClick()} applyThrottle />
            </div>
        )
    }

    return(
        <>
            <Dialog className="send-email-modal" header={header} visible={props.visible} footer={footerContent} style={{ width: '50vw',minHeight:"35%" }} onHide={() => {props.onHide(); setFormErrors({}); setReasonText("")}}>
                <div className="grid">
                    <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                        <TextAreaField name="remarks" labelText="" rows={5}  placeholder={placeholder} value={reasonText} onChange={(e) => handleOnChange(e)} errorMessage={formErrors.cancellationReason} />
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default RemarksDialog